<iframe  #videoFrame scrolling="no" frameborder="0" allowfullscreen="" class="vidio-embed embed-responsive-item rounded" id="video-embed"
         [src]="url | safe" title="Video Frame"></iframe>
